import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SocialFeeds from "../components/SocialFeeds";
import VideoGallery from "../components/VideoGallery";
import VideoSlider from "../components/WelcomeVideo";
import HotelCards from "../components/HotelCards";
import AboutUs from "../components/AboutSection";
import PopularDestination from "../components/PopularDestination";
import Newaboutus from "../components/Newaboutus";
import FaqSection from "../components/FaqSection";
import { REACT_APP_API_URL } from "../env";
import axios from "axios";

const Homepage = ({ setDestinations }) => {
  const [showEventModal, setShowEventModal] = useState(false);
  const navigate = useNavigate();
  const [desktopVideo1, setDesktopVideo1] = useState("");
  const [mobileVideo1, setMobileVideo1] = useState("");
  const [desktopVideo2, setDesktopVideo2] = useState("");
  const [mobileVideo2, setMobileVideo2] = useState("");

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowEventModal(true);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    setShowEventModal(true);
    const fetchHomepageVideos = async () => {
      try {
        const res = await axios.get(`${REACT_APP_API_URL}/api/dashboard/admin/list-all-videos?mode=active`);
        const rows = res.data.data || [];
        const row = Array.isArray(rows) ? rows[0] : rows;
        if (!row) return;
        if (row.vchVideo1Mode === "file") {
          setDesktopVideo1(row.vchVideo1DesktopPath ? `${REACT_APP_API_URL}${row.vchVideo1DesktopPath}` : "");
          setMobileVideo1(row.vchVideo1MobilePath ? `${REACT_APP_API_URL}${row.vchVideo1MobilePath}` : "");
        } else {
          setDesktopVideo1(row.vchVideo1DesktopLink);
          setMobileVideo1(row.vchVideo1MobileLink || row.vchVideo1DesktopLink);
        }
        if (row.vchVideo2Mode === "file") {
          setDesktopVideo2(row.vchVideo2DesktopPath ? `${REACT_APP_API_URL}${row.vchVideo2DesktopPath}` : "");
          setMobileVideo2(row.vchVideo2MobilePath ? `${REACT_APP_API_URL}${row.vchVideo2MobilePath}` : "");
        } else {
          setDesktopVideo2(row.vchVideo2DesktopLink);
          setMobileVideo2(row.vchVideo2MobileLink || row.vchVideo2DesktopLink);
        }
      } catch (err) {
        console.error("Failed to load homepage videos", err);
      }
    };

    fetchHomepageVideos();
  }, []);

  return (
    <div className="homepage-container">
      <VideoSlider desktopVideoSrc={desktopVideo1} mobileVideoSrc={mobileVideo1} />
      <VideoSlider desktopVideoSrc={desktopVideo2} mobileVideoSrc={mobileVideo2} />

      <AboutUs />
      <HotelCards />
      <PopularDestination setDestinations={setDestinations} />
      <VideoGallery />
      <SocialFeeds />
      <Newaboutus />
      <FaqSection />

      {showEventModal && (
        <div className="event-overlay">
          <div className="event-modal-box">

            {/* Close Button */}
            <button
              className="event-close-btn"
              onClick={() => setShowEventModal(false)}
            >
              ✕
            </button>

            {/* Image Container */}
            <div className="event-image-wrapper">
              <img
                src="/assets/Events/Weblite_Popup.webp"
                alt="Events"
              />

              {/* Overlay Button */}
              <button
                className="event-overlay-btn"
                onClick={() => navigate("/tours")}
              >
                Enquire Now
              </button>
            </div>

          </div>
        </div>
      )}

    </div>
  );
};

export default Homepage;
